import { combineReducers } from 'redux';

import auth from './auth/reducer';
import statements from './statements/reducer';
import filter from './filter/reducer';
import user from './user/reducer';
import upload from './upload/reducer';
import download from './download/reducer';
import exports from './exports/reducer';
import fileGeneration from './file-generation/reducer';
import { logout as LogoutAction } from './auth/actions';
import { AuthTypes } from './auth/types';

const appReducer = combineReducers({
  auth,
  user,
  statements,
  filter,
  upload,
  download,
  exports,
  fileGeneration,
});

const rootReducer = (
  state: ReturnType<typeof appReducer> | undefined,
  action: ReturnType<typeof LogoutAction>
) => {
  // when a logout action is dispatched it will reset redux state
  if (action.type === AuthTypes.Logout) {
    // eslint-disable-next-line no-param-reassign
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
